export const FEEDBACK_ACCEPT_VERSION = '3.0.0';
export const FEEDBACK_ACCEPT_VERSION_200 = '2.0.0';
export const FEEDBACK_API_ERROR_GROUPING_KEY = 'user_feedback_error';

export enum FeedbackScreenEnum {
  reports = 'reports',
  appointments = 'appointments',
  cancel_subscription = 'cancel_subscription',
}

export interface IFeedbackCard {
  titleKey: string;
  descriptionKey: string;
}

export interface IScreenData {
  [screenId: string]: any;
}

export interface IFeedbackCardDismissed {
  [accountId: string]: {
    [featureName: string]: boolean;
  };
}

export function getHideFeedbackCardKey(featureName: string, accountId: string) {
  return `hide_feedback_card_${featureName}_account_${accountId}`;
}

// Start dynamic form interfaces
export interface IScreenFieldWithLabel {
  label: string;
}

export enum ScreenInputTypesEnum {
  input_single_selection = 'input_single_selection',
  radio_button_with_optional_comment = 'radio_button_with_optional_comment',
  radio_button = 'radio_button',
  input_text = 'input_text',
}

export interface IScreenInput {
  // common
  input_type: ScreenInputTypesEnum;
  input_id: string;
  options?: IScreenInput[];
  label?: string;

  // inputs
  placeholder?: string;

  // radio button
  radio_button?: IScreenInput;
  comment?: IScreenInput;
}

/**
 * Cancel subscription screen as defined by 3.0.0 contract
 * https://invoice2go.atlassian.net/wiki/spaces/CORE/pages/717226153/2020-02-05+SA+Reporting+feedback#Stage-2---Dynamic-screen-content---version-3.0.0
 */
export interface ICancelSubscriptionScreen {
  feedback_question: IScreenFieldWithLabel;
  modal_title: IScreenFieldWithLabel;
  cta_submit: IScreenFieldWithLabel;
  cta_cancel: IScreenFieldWithLabel;
  inputs: IScreenInput[];
}
